const SCENES_KEY = 'orchestrator_scenes';
const CURRENT_SCENE_KEY = 'orchestrator_current_scene';

export function loadScenes() {
  try {
    const raw = localStorage.getItem(SCENES_KEY);
    if (!raw) return [];
    return JSON.parse(raw) || [];
  } catch (error) {
    console.warn('Failed loading scenes', error);
    return [];
  }
}

export function saveScenes(scenes) {
  try {
    localStorage.setItem(SCENES_KEY, JSON.stringify(scenes));
  } catch (error) {
    console.warn('Failed to save scenes to localStorage', error);
  }
}

export function getStoredSceneId() {
  try {
    return localStorage.getItem(CURRENT_SCENE_KEY);
  } catch (error) {
    console.warn('Failed to read current scene id', error);
    return null;
  }
}

export function setStoredSceneId(sceneId) {
  try {
    if (sceneId) {
      localStorage.setItem(CURRENT_SCENE_KEY, sceneId);
    } else {
      localStorage.removeItem(CURRENT_SCENE_KEY);
    }
  } catch (error) {
    console.warn('Failed to write current scene id', error);
  }
}

export { SCENES_KEY, CURRENT_SCENE_KEY };
